module.exports = __webpack_public_path__ + "static/media/YF40_0.0786eaaf.jpg";